/**
 * API addresses. Change the links here; every *Api.ts file in this folder uses them.
 *
 *   local  -> backend on your computer (npm run dev:backend)
 *   server -> deployed backend
 *
 * `npm run dev` uses local, `npm run build` uses server.
 * Force one with VITE_API_MODE=local|server, or override the link with VITE_API_URL.
 */
export const API_URLS = {
  local: 'http://localhost:4000/api/v1',
  server: 'https://loyalty.opssolution.tech/api/v1',
} as const;

export type ApiMode = keyof typeof API_URLS;

export const API_MODE: ApiMode =
  (import.meta.env.VITE_API_MODE as ApiMode | undefined) ?? (import.meta.env.DEV ? 'local' : 'server');

export const API_BASE_URL = (import.meta.env.VITE_API_URL || API_URLS[API_MODE]).replace(/\/$/, '');

/** Health checks sit next to the API: http://localhost:4000/health/ready */
export const HEALTH_BASE_URL = API_BASE_URL.replace(/\/api\/v1$/, '');

if (!API_BASE_URL) {
  console.error(`API link for "${API_MODE}" is empty. Set it in src/helpers/api.ts or VITE_API_URL.`);
}
